var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "heart_svg__outline",
    d: "M12 22c15.84452-10.25004 9.57953-19.12192 3.46571-17.88428C14.24546 4.36275 13.03122 5.0125 12 6.1344 5.80209-.6085-7.00693 9.70415 12 22z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "#000"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/heart.svg";
export { SvgHeart as ReactComponent };